import Input from "@visa/vds/input";
import React from "react";
import { useController } from "react-hook-form";
import { FormHelper } from "../_helpers/FormHelper";

function MCSControlInput(props) {
  const { field, fieldState } = useController(props);
  const handleChange = (e) => {
    field.onChange(e);
    props.handleChange();
  };
  return (
    <Input
      name={props.name}
      readOnly={props.readOnly}
      value={props.value ?? field.value}
      onChange={handleChange}
      label={props.label}
      maxLength={props.maxLength}
      invalid={fieldState.invalid}
      showErrorText={fieldState.invalid}
      errorText={FormHelper.renderErrorMsg(fieldState.error)}
      placeholder={props.placeholder}
      useNativePlaceholder={props.useNativePlaceholder}
    />
  );
}

export default MCSControlInput;
